import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getThumbClasses = ({ _isDragging }, thumbType) => {
  const classes = [
    "rounded-full",
    "border",
    "border-neutral-200",
    "bg-neutral-0",
    "shadow-xs",
    "hover:border-2",
    "focus-visible:border-2",
    "focus-visible:border-secondary-300",
    "outline-none",
    "cursor-grab"
  ];
  classes.push(_isDragging === thumbType ? "border-2 border-secondary-300" : "border-neutral-200");
  return concatClasses(classes);
};
export {
  getThumbClasses
};
